import { NormalizedCostWidgetSetupType } from "@/store/dashboards/utils/types/setups/normalizedCostWidgetSetupType";

export const normalizedCostWidgetSetupDefaultData: NormalizedCostWidgetSetupType =
  {
    widgetType: "normalized_cost",
    name: "Normalized Cost",
    dates: { label: "last_twelve_months" },
    aggregation: {
      actual_total_cost: true,
      average_normalized_monthly_cost: true,
      forecasted_month_end_cost: true,
    },
    visualization: {
      chart_type: "line",
      scale: "linear",
      show_legends: true,
      actual_total_cost: true,
      normalized_total_cost: true,
    },
    trendType: "month_over_month",
    forecastOption: "month",
  };
